module.exports = __webpack_public_path__ + "static/media/icon-gh-blue.8f71d03f.svg";